// Google Analytics 4 utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const analytics = {
  // Track page views
  pageView: (path: string, title: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: path,
        page_title: title
      });
    }
  },

  // Track events
  event: (eventName: string, parameters?: Record<string, any>) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, parameters);
    }
  },

  // E-commerce tracking
  purchase: (transactionId: string, value: number, items: any[]) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'purchase', {
        transaction_id: transactionId,
        value: value,
        currency: 'GBP',
        items: items
      });
    }
  },

  // Track product views
  viewItem: (itemId: string, itemName: string, category: string, value: number) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'view_item', {
        currency: 'GBP',
        value: value,
        items: [{
          item_id: itemId,
          item_name: itemName,
          item_category: category,
          price: value,
          quantity: 1
        }]
      });
    }
  },

  // Track add to cart
  addToCart: (itemId: string, itemName: string, category: string, value: number, quantity: number = 1) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'add_to_cart', {
        currency: 'GBP',
        value: value,
        items: [{
          item_id: itemId,
          item_name: itemName,
          item_category: category,
          price: value,
          quantity: quantity
        }]
      });
    }
  },

  // Track custom events
  customEvent: (eventName: string, category?: string, label?: string, value?: number) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  }
};